export interface ThereminvoxSoundMeta {
    id: string;
    originalPath: string;
    originalName: string;
}

export const emptyMeta: ThereminvoxSoundMeta = {
    id: '',
    originalPath: '',
    originalName: '',
};

export type InnerSoundMetaState = 'uploaded' | 'uploading' | 'error';

export interface InnerSoundMeta {
    id: string;
    outerMeta?: ThereminvoxSoundMeta;
    state: InnerSoundMetaState;
    file?: File;
}

export interface ThereminvoxTestingModeProps {
    repeatSoundInside: boolean;
    noOverlaySamples: boolean;
    stopOnCeil: boolean;
    stopAllSounds: () => void;
}

export const isValidThereminvoxSoundMeta = (soundMeta: ThereminvoxSoundMeta) =>
    Boolean(soundMeta && soundMeta.id && soundMeta.originalPath && soundMeta.originalName);

export const thereminvoxSoundsDragHandleId = 'drag-handle';

export interface DropResult<T> {
    removedIndex: number | null;
    addedIndex: number | null;
    payload: T;
}
